import { createGenericTypes, createGenericActions } from "utils/createAction";

export const getRequestorsTypes = createGenericTypes("GET_REQUESTOR");
export const getRequestorsActions = createGenericActions(getRequestorsTypes);
